"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _emotion = require("emotion");

var _reactEmotion = _interopRequireDefault(require("react-emotion"));

var _arrowRight = _interopRequireDefault(require("react-feather/dist/icons/arrow-right"));

var _externalLink = _interopRequireDefault(require("react-feather/dist/icons/external-link"));

var _propTypes = require("prop-types");

var _base = _interopRequireDefault(require("../../shared/base"));

var _font = _interopRequireDefault(require("../../shared/font"));

var _utils = require("../../shared/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var transparent = function transparent(props) {
  return /*#__PURE__*/(0, _emotion.css)("color:", (0, _utils.getTextColor)(props, true), ";background-color:transparent;padding:0;&:hover,&:focus{background-color:transparent;color:", (0, _utils.shade)((0, _utils.getTextColor)(props, true), -0.1), ";}");
};

var primary = function primary(props) {
  return /*#__PURE__*/(0, _emotion.css)("color:", (0, _utils.getProperty)(props, 'textLight'), ";background-color:", (0, _utils.getProperty)(props, 'primaryColor'), ";&:hover,&:focus{background-color:", (0, _utils.shade)((0, _utils.getProperty)(props, 'primaryColor'), -0.1), ";}");
};

var success = function success(props) {
  return /*#__PURE__*/(0, _emotion.css)("color:", (0, _utils.getProperty)(props, 'textLight'), ";background-color:", (0, _utils.getProperty)(props, 'successColor'), ";&:hover,&:focus{background-color:", (0, _utils.shade)((0, _utils.getProperty)(props, 'successColor'), -0.1), ";}");
};

var warning = function warning(props) {
  return /*#__PURE__*/(0, _emotion.css)("color:", (0, _utils.getProperty)(props, 'textLight'), ";background-color:", (0, _utils.getProperty)(props, 'warningColor'), ";&:hover,&:focus{background-color:", (0, _utils.shade)((0, _utils.getProperty)(props, 'warningColor'), -0.1), ";}");
};

var alert = function alert(props) {
  return /*#__PURE__*/(0, _emotion.css)("color:", (0, _utils.getProperty)(props, 'textLight'), ";background-color:", (0, _utils.getProperty)(props, 'alertColor'), ";&:hover,&:focus{background-color:", (0, _utils.shade)((0, _utils.getProperty)(props, 'alertColor'), -0.1), ";}");
};

var dark = function dark(props) {
  return /*#__PURE__*/(0, _emotion.css)("color:", (0, _utils.getProperty)(props, 'textLight'), ";background-color:", (0, _utils.getProperty)(props, 'darkColor'), ";&:hover,&:focus{background-color:", (0, _utils.shade)((0, _utils.getProperty)(props, 'darkColor'), -0.1), ";}");
};

var disabled = /*#__PURE__*/(0, _emotion.css)("color:#fafafa;background-color:#dedede;cursor:not-allowed;");

var shadow = function shadow(props) {
  return /*#__PURE__*/(0, _emotion.css)("box-shadow:0 3px 3px 0 rgba(0,0,0,0.1);&:hover,&:focus{box-shadow:", props.disabled ? '0 3px 3px 0 rgba(0,0,0,.1)' : '0 6px 6px 0 rgba(0,0,0,.1)', ";}");
};

var small = /*#__PURE__*/(0, _emotion.css)("padding:0 14px;height:28px;font-size:0.88rem;");
var big = /*#__PURE__*/(0, _emotion.css)("padding:0 25px;height:44px;font-size:1rem;line-height:1rem;");
var block = /*#__PURE__*/(0, _emotion.css)("display:flex;");

var ghost = function ghost(props) {
  return /*#__PURE__*/(0, _emotion.css)("background:transparent;border:1px solid ", (0, _utils.getProperty)(props, 'primaryColor'), ";color:", (0, _utils.getProperty)(props, 'primaryColor'), " !important;&:hover,&:focus{background:transparent;}");
};

var arrowStyles = /*#__PURE__*/(0, _emotion.css)("svg{height:1.3rem;margin-left:5px;transition:0.3s ease-in-out;}&:hover,&:focus{svg{padding-left:3px;}}");
var linkStyles = /*#__PURE__*/(0, _emotion.css)("svg{height:1.3rem;margin-right:5px;transition:0.3s ease-in-out;}");
var Button = /*#__PURE__*/(0, _reactEmotion.default)('a', {
  target: "e7ric1x0"
})(_base.default, ";", _font.default, ";font-size:1rem;line-height:1rem;display:inline-flex;justify-content:center;align-items:center;padding:0 22px;height:40px;border-radius:", function (props) {
  return props.theme.borderRadius ? props.theme.borderRadius : '3px';
}, ";cursor:pointer;background-color:#eeeded;user-select:none;color:", function (props) {
  return (0, _utils.getTextColor)(props);
}, ";transition:all .3s ease;font-weight:", function (props) {
  return props.bold ? '600' : '400';
}, ";text-transform:", function (props) {
  return props.uppercase ? 'uppercase' : 'none';
}, ";letter-spacing:0.01rem;text-decoration:none;white-space:nowrap;&:hover,&:focus{text-decoration:none;background-color:", (0, _utils.shade)('#eeeded', -0.1), ";}", function (props) {
  return props.small ? small : null;
}, "\n\t", function (props) {
  return props.big ? big : null;
}, "\n\t", function (props) {
  return props.block ? block : null;
}, "\n\t", function (props) {
  return props.primary ? primary : null;
}, "\n\t", function (props) {
  return props.success ? success : null;
}, "\n\t", function (props) {
  return props.warning ? warning : null;
}, "\n\t", function (props) {
  return props.alert ? alert : null;
}, "\n\t", function (props) {
  return props.dark ? dark : null;
}, "\n\t", function (props) {
  return props.shadow ? shadow : null;
}, "\n\t", function (props) {
  return props.disabled ? disabled : null;
}, "\n\t", function (props) {
  return props.ghost ? ghost : null;
}, "\n\t", function (props) {
  return props.transparent ? transparent : null;
}, "\n\t", function (props) {
  return props.arrow ? arrowStyles : null;
}, "\n\t", function (props) {
  return props.link ? linkStyles : null;
});

var StyledButton = function StyledButton(_ref) {
  var children = _ref.children,
      arrow = _ref.arrow,
      link = _ref.link,
      props = _objectWithoutProperties(_ref, ["children", "arrow", "link"]);

  return _react.default.createElement(Button, _extends({
    arrow: arrow,
    link: link
  }, props), _react.default.createElement(_react.Fragment, null, link && // eslint-disable-next-line
  _react.default.createElement(_externalLink.default, null), children, arrow && _react.default.createElement(_arrowRight.default, null)));
};

StyledButton.propTypes = {
  children: _propTypes.node,
  arrow: _propTypes.bool,
  link: _propTypes.bool
};
var _default = StyledButton;
exports.default = _default;